import { HorizontalBar } from 'react-chartjs-2'
import 'chartjs-plugin-datalabels'
import PropTypes from 'prop-types'

import './ChartRectangeDraw'
import { getCuttedString } from '../../BuildingDashboard/BuildingEssentials/helpers'
import { getDiffDirectionSymbol } from '../../BuildingAnalytics/helpers'

const defaultData = {
  labels: [
    'Photo identification',
    'Car driver license (C-Class)',
    'Working at heights',
    'Certificate IV - Mechanical Fitter',
  ].map((name) => getCuttedString(name, 15, 13)),
  datasets: [
    {
      label: 'Expiring Soon',
      backgroundColor: '#7978EB',
      data: [12, 4, 15, 2],
    },
  ],
}

let defaultOptions = {
  cornerRadius: 5,
  plugins: {
    customScale: {
      grace: 1,
    },
    topLabels: true,
    datalabels: {
      display: true,
      color: 'white',
      anchor: 'center',
      align: 'center',
    },
  },
  legend: {
    display: false,
  },
  scales: {
    xAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
        display: false,
      },
    ],
    yAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },

  tooltips: {
    callbacks: {
      title: function (tooltipItem, data) {
        return data['labels'][tooltipItem[0]['index']]
      },
    },
    caretSize: 0,
    backgroundColor: 'rgba(255,255,255,0.9)',
    titleFontSize: 16,
    borderColor: '#EAE9E9',
    cornerRadius: 6,
    borderWidth: 1,
    titleFontColor: '#000',
    bodyFontColor: '#000',
    bodyFontSize: 14,
  },
}

const gracePlugin = {
  id: 'customScale',
  beforeLayout: (chart, options, _c) => {
    let max = Number.MIN_VALUE
    let min = Number.MAX_VALUE
    let grace = options.grace || 0

    chart.data.datasets.forEach((dataset) => {
      max = Math.max(max, Math.max(...dataset.data))
      min = Math.min(min, Math.min(...dataset.data))
    })

    chart.options.scales.xAxes[0].ticks.suggestedMax = max + grace
    chart.options.scales.xAxes[0].ticks.suggestedMin = min - grace
  },
}

const topLabelsPlagin = {
  id: 'topLabels',
  afterDatasetsDraw(chart, _args, _pluginOptions) {
    const { ctx } = chart

    const datasetData = []
    chart.data.datasets.forEach((dataset, i) => {
      datasetData[i] = {
        ...datasetData[i],
        value: dataset.data[0],
        id: i,
        data: dataset._meta[Object.keys(dataset._meta)[0]].data[0]._view,
        diff: dataset.diff,
        hidden: Object.values(dataset._meta)[0].hidden,
      }
    })

    datasetData.forEach((dataset) => {
      ctx.textAlign = 'center'
      ctx.font = '12px sans-serif'
      ctx.fillStyle = dataset.diff[0] === '-' ? '#ce2c21' : '#548671'
      ctx.textAlign = 'center'

      if (!dataset.hidden && dataset.diff !== '-') {
        ctx.fillText(
          `${getDiffDirectionSymbol(dataset.diff)} ${dataset.diff}%`,
          dataset.data.x + 40,
          dataset.data.y,
        )
      }
    })
  },
}

const HorizontalChart = ({
  data = defaultData,
  options = defaultOptions,
  wrapperStyles = { width: '500px', height: '400px' },
  withPlugins,
  height = 'auto',
}) => {
  return (
    <div style={wrapperStyles}>
      <HorizontalBar
        data={data}
        options={options}
        height={height}
        plugins={withPlugins && [gracePlugin, topLabelsPlagin]}
      />
    </div>
  )
}

HorizontalChart.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  wrapperStyles: PropTypes.object,
  withPlugins: PropTypes.bool,
  height: PropTypes.number,
}

export default HorizontalChart
